import Component from 'gia/Component';
import gsap from 'gsap';
import drawSVG from '../vendor/gsap-bonus-umd/DrawSVGPlugin'
gsap.registerPlugin(drawSVG)

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element

    this.animate()
  }

  animate()
  {
    console.log(this.ref.shape[0].querySelector('svg path'));
    gsap.fromTo(
      this.ref.shape[0].querySelector('svg path'),
      {
        drawSVG:`0% 0%`
      },
      {
        drawSVG:`50% 100%`,
        duration:5
      }
    )
  }

  unmount()
  {

  }
}
